import { Injectable } from '@angular/core';
import { PctConfigModel } from '../../models/pct-config/pct-config.model';
import { map, Observable } from 'rxjs';
import { EmployeeRoleEnum } from '../../models/employee/employee-role.enum';
import { toMidnight } from '../../utils/date-utils';

@Injectable()
export abstract class PctConfigService {

    public abstract findRemConfigByCountryAndRole(country: string, role: EmployeeRoleEnum): Observable<PctConfigModel[]>;

    // Active PCT must be resolved on the frontend using today's date,
    // because we dont sync CouchDB every day.
    public findActivePCT(country: string, role: EmployeeRoleEnum): Observable<PctConfigModel | null> {

        const today = new Date();

        return this.findRemConfigByCountryAndRole(country, role).pipe(
            map((configs: PctConfigModel[]) => {

                if (!configs || configs.length === 0) {
                    return null;
                }
                const todayMid = toMidnight(today);

                const active = configs.find(cfg => {
                    const start = toMidnight(new Date(cfg.startDate));
                    const end = cfg.endDate ? toMidnight(new Date(cfg.endDate)) : null;

                    return start <= todayMid && (end === null || todayMid <= end);
                });

                return active ?? null;
            })
        );
    }

}
